import React, { useCallback } from 'react';
import { StyledFilterTrigger, StyledFilterGroup, StyledGroupTitle } from './styled';
import ChevronDown from '$icons/chevron-down.svg';
import ChevronUp from '$icons/chevron-up.svg';
import { useFilterUIState } from '~/features/productsList/hooks';

type FiltersGroupProps = {
    title?: string;
    attribute: string;
};
export const FiltersGroup = ({ title, attribute }: FiltersGroupProps) => {
    const {
        selectedFilterGroup,
        setSelectedFilterGroup,
        setIsFilterDrawerOpen,
        isFilterDrawerOpen,
    } = useFilterUIState();

    const isOpen = selectedFilterGroup === attribute && isFilterDrawerOpen;

    const toggleContent = useCallback(() => {
        if (isOpen) {
            setIsFilterDrawerOpen(false);
        } else {
            setIsFilterDrawerOpen(true);
        }
        setSelectedFilterGroup(attribute);
    }, [attribute, isOpen, setIsFilterDrawerOpen, setSelectedFilterGroup]);

    return (
        <StyledFilterGroup>
            <div>
                <StyledFilterTrigger isOpen={isOpen} onClick={toggleContent}>
                    <StyledGroupTitle>{title}</StyledGroupTitle>
                    {!isOpen ? (
                        <ChevronDown aria-hidden="true" />
                    ) : (
                        <ChevronUp aria-hidden="true" />
                    )}
                </StyledFilterTrigger>
            </div>
        </StyledFilterGroup>
    );
};
